import { useEffect } from 'react';
import Cookies from 'js-cookie';
import { Alert, AlertIcon, Button, FormControl, FormLabel, Heading, Input, Stack, Text } from '@chakra-ui/react';
import { Title } from '../../../atoms/Title';
import { clearCognitoCookies } from '../clearCognitoCookies';

export interface LoginProps {
  errors: Array<string>;
  samlEnabled?: boolean;
  username?: string;
  password?: string;
  isStudentApp?: boolean;
  onUsernameChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onPasswordChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onLoginClick: () => void;
  onForgotPasswordClick: () => void;
  setIsLoading: (val: boolean) => void;
}

const Login = (props: LoginProps) => {
  const {
    errors,
    samlEnabled,
    username,
    password,
    isStudentApp,
    onUsernameChange,
    onPasswordChange,
    onLoginClick,
    onForgotPasswordClick,
    setIsLoading,
  } = props;

  const handleLogin = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsLoading(true);
    onLoginClick();
  };

  useEffect(() => {
    clearCognitoCookies(Cookies);
  }, []);

  const title = isStudentApp ? 'Log in' : 'Log in to Enroly';

  return (
    <>
      <Title title={title} />

      <Heading as="h1" mb="6">
        {title}
      </Heading>

      {errors.length > 0 ? (
        <Alert status="error" mb="4" data-selector="login-error">
          <AlertIcon />
          {errors}
        </Alert>
      ) : null}

      {!samlEnabled ? (
        <form onSubmit={handleLogin}>
          <FormControl mb="4">
            <FormLabel fontSize="lg" htmlFor="username">
              {isStudentApp ? 'Email address' : 'Username'}
            </FormLabel>

            <Input
              id="username"
              data-selector="login-email"
              autoComplete={isStudentApp ? 'email' : 'username'}
              type={isStudentApp ? 'email' : 'text'}
              size="lg"
              onChange={onUsernameChange}
              value={username}
              isRequired
              data-sentry-mask
            />
          </FormControl>

          <FormControl mb="8">
            <FormLabel fontSize="lg" htmlFor="current-password">
              Password
            </FormLabel>

            <Input
              id="current-password"
              data-selector="login-password"
              autoComplete="current-password"
              size="lg"
              type="password"
              onChange={onPasswordChange}
              value={password}
              isRequired
              data-sentry-mask
            />
          </FormControl>

          <Stack spacing="3">
            <Button
              id="login"
              data-selector="login-submit"
              type="submit"
              size="lg"
              variant="solid"
              isDisabled={username?.trim() === '' || (password || '').trim() === ''}
            >
              Log in
            </Button>

            <Button
              data-testid="reset-password"
              data-selector="reset-password-link"
              size="lg"
              variant="ghost"
              onClick={onForgotPasswordClick}
            >
              Reset password
            </Button>
          </Stack>
        </form>
      ) : (
        <Text>Please wait while you are redirected to log in via your identity provider.</Text>
      )}
    </>
  );
};

export default Login;
